import { Chip, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const TonoMensaje = () => {
  const { promptData, setPromptData } = useActividadesContext();
  const [tonoSeleccionado, setTonoSeleccionado] = useState("");

  const opcionesTono = [
    "Positivo/Constructivo",
    "Colaborativo",
    "Amable/Acogedor",
    "Honesto/Claro",
  ];

  useEffect(() => {
    if (promptData.tono) {
      setTonoSeleccionado(promptData.tono);
    }
  }, [promptData.tono]);

  const handleTonoClick = (tono) => {
    setTonoSeleccionado(tono);

    setPromptData((prevData) => ({
      ...prevData,
      tono: tono,
    }));
  };

  return (
    <Grid container spacing={1} sx={{ mb: 2 }}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          {" "}
          Tono del Mensaje{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Stack direction="row" spacing={2} sx={{ flexWrap: "wrap" }}>
          {opcionesTono.map((tono) => (
            <Chip
              key={tono}
              label={tono}
              onClick={() => handleTonoClick(tono)}
              variant="outlined"
              sx={{
                m: 1,
                fontFamily: "montserrat",
                backgroundColor:
                  tonoSeleccionado === tono ? "#336B87" : "#FFFFFF",
                color: tonoSeleccionado === tono ? "#FFFFFF" : "#209099",
                borderColor:
                  tonoSeleccionado === tono ? "transparent" : "#209099",
                borderWidth: "2px",
                ":hover": {
                  backgroundColor: "#F9DA96",
                  borderColor: "#209099",
                  color: "#209099",
                  cursor: "pointer",
                },
                width: "200px", // Ajusta el ancho de los chips para que sean más uniformes
                textAlign: "center",
              }}
            />
          ))}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default TonoMensaje;
